import type { UsageLimit, UsageLimitName } from "@/features/auth/api/usage";
import { limitStatus } from "@/features/usage/constants";
import { useUsage } from "@/features/usage/hooks/useUsage";
import { useMemo } from "react";

const useNamedLimit = (name: UsageLimitName) => {
  const usage = useUsage();
  const limit: UsageLimit | undefined = usage.data?.limits[name];
  const { isAtLimit, isApproachingLimit } = useMemo(
    () => limitStatus(limit),
    [limit],
  );
  return { ...usage, limit, isAtLimit, isApproachingLimit };
};

export const useDailyPrompts = () => useNamedLimit("dailyPrompts");
export const useDailyMaps = () => useNamedLimit("dailyMaps");
export const useWorkspaceStorage = () => useNamedLimit("workspaceStorage");
